module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v("\n  滿\n  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.deliveryWays.price),
      expression: "deliveryWays.price",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control w-90 inline-block",
    attrs: {
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.deliveryWays.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deliveryWays, "price", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text"
  }, [_vm._v("\n      外送訂單可下單的最低金額門檻。若需設定訂單金額與對應的外送距離，可按「綠色+」按鈕設定。\n    ")])], 1), _vm._v("\n  元即可外送\n  "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.addOtherDelivery()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _vm._l((_vm.deliveryOtherKM), function(delivery, index) {
    return _c('span', {
      key: index
    }, [_c('br'), _vm._v(" "), _c('hr'), _vm._v("\n    滿\n    "), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (delivery.price),
        expression: "delivery.price",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text",
        "disabled": index === 0
      },
      domProps: {
        "value": (delivery.price)
      },
      on: {
        "change": function($event) {
          return _vm.changeOtherDelivery()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(delivery, "price", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v("\n    元可外送\n    "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (delivery.distance_km),
        expression: "delivery.distance_km",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "form-control w-90 inline-block",
      attrs: {
        "placeholder": "",
        "type": "text"
      },
      domProps: {
        "value": (delivery.distance_km)
      },
      on: {
        "change": function($event) {
          return _vm.changeOtherDelivery()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(delivery, "distance_km", _vm._n($event.target.value))
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    }), _vm._v("\n    公里以內 "), (!_vm.maxDeliveryDistanceKM && index === _vm.deliveryOtherKM.length - 1) ? _c('span', [_vm._v("(以上)")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          return _vm.removeOtherDelivery(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])])
  }), _vm._v(" "), _c('hr'), _vm._v("\n  最遠可送\n  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.maxDeliveryDistanceKM),
      expression: "maxDeliveryDistanceKM",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control w-90 inline-block",
    attrs: {
      "maxlength": "6",
      "placeholder": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.maxDeliveryDistanceKM)
    },
    on: {
      "change": function($event) {
        return _vm.changeOtherDelivery()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxDeliveryDistanceKM = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v("\n  公里\n")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex text-14 m-b-10"
  }, [_c('div', {
    staticClass: "text-red m-r-5"
  }, [_vm._v("＊")]), _vm._v("\n    因圖資系統計算有機會產生偏差，故系統將自動保留 100 公尺的誤差值。"), _c('br'), _vm._v("\n    例如：若您的門檻設定為 1000 公尺，客人的距離為 1050 公尺，系統將視為符合門檻。\n  ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d855961"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Brand/Temp/DeliveryLimit.vue
// module id = 2349
// module chunks = 1